import { useState, useMemo } from 'react';

const usePagination = (data = [], pageSize = 10) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(data.length / pageSize));

  // Reset to page 1 when data changes
  const safePage = Math.min(currentPage, totalPages);

  const pageData = useMemo(() => {
    const start = (safePage - 1) * pageSize;
    return data.slice(start, start + pageSize);
  }, [data, safePage, pageSize]);

  const goToPage = (page) => setCurrentPage(Math.max(1, Math.min(page, totalPages)));

  return { pageData, currentPage: safePage, totalPages, goToPage, total: data.length };
};

export default usePagination;
